import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    PerformModAction,
    PerformModActionVariables,
} from "./__graphql-types__/PerformModAction.ts";

export const PERFORM_MOD_ACTION: GqlOperation<
    PerformModAction,
    PerformModActionVariables
> = gqlOp(gql`
    mutation PerformModAction(
        $modAction: ModAction!
        $entityKey: String!
        $intoType: FeedbackType
    ) {
        performModAction(
            modAction: $modAction
            entityKey: $entityKey
            intoType: $intoType
        ) {
            error {
                code
            }
        }
    }
`);
